import React from 'react';
import { TextFieldProps } from '@material-ui/core';
import NumberMaskedField from '../NumberMaskedField';

export type PhoneFieldProps = TextFieldProps & {
  MaskedProps?: {
    format?: string;
    mask?: string;
    prefix?: string;
  };
};

const defaultMaskedProps = {
  format: '###-###-####',
  disabled: false,
};

export const PhoneField = ({ MaskedProps, name, InputProps, ...props }: PhoneFieldProps): JSX.Element => {
  return (
    <NumberMaskedField
      MaskedProps={{
        ...defaultMaskedProps,
        ...MaskedProps,
      }}
      InputProps={{
        ...InputProps,
        name: name,
      }}
      {...props}
    />
  );
};

export default PhoneField;
